import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios';

const baseUrl = process.env.REACT_APP_BASE_URL;

export const sendWhatsappMsg = createAsyncThunk('sendWhatsappMsg', async ({postData,id}, thunkAPI) => {
    //console.log("id", id);
    try {
        const response = await axios.post(`${baseUrl}?apicall=sendWhatsappMsgs&id=${id}`, postData, {
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
});


